import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Router } from '@angular/router';
import { Observable } from 'rxjs-compat/Observable'
import { ServiceBase } from '../../../infrastructure/serviceBase.component';
import { LabApiConfiguration } from '../apiConfiguration';

export interface DeltaLogDto {
 Id: number;
    SpecimenTransId: number;
    OrderId: number;
    SpecimenNo: number;
    TestCode: string;
    TestTitle: string;
    CurrentResult: number;
    PreviousResult: number;
    DeltaValue: number;
    DeltaPercentage: number;
    Status: number; // 1=Normal, 2=Warning, 3=Critical
    ResolveBy: number;
    CreatedDate: Date;
    AllowOverride: boolean;
    OverrideCommentRequired: boolean;
}


export interface DeltaResolveDto {
    DeltaLogId: number;
    ResolveAction: number; // 1=Override, 2=Rerun, 3=Reject
    ResolveComment: string;
}

@Injectable()
export class DeltaCheckService extends ServiceBase {

    private actionUrl: string;
    private _getUnresolvedDeltaLogs: string;
    private _resolveDeltaLog: string;

    constructor(private _http: HttpClient, private _configuration: LabApiConfiguration, private _router: Router) {
        super();
        this.actionUrl = _configuration.server;
        this._getUnresolvedDeltaLogs = this.actionUrl + _configuration.deltaCheckConfiguration.getUnresolvedDeltaLogs;
        this._resolveDeltaLog = this.actionUrl + _configuration.deltaCheckConfiguration.resolveDeltaLog;
    }

    getUnresolvedDeltaLogs = (specimenTransIds: number[]): Observable<DeltaLogDto[]> => {
        return this._http.post<DeltaLogDto[]>(this._getUnresolvedDeltaLogs, {
            SpecimenTransIds: specimenTransIds
        })
    }

    resolveDeltaLog = (data: DeltaResolveDto): Observable<any> => {
        return this._http.post<any>(this._resolveDeltaLog, data)
    }
}